var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalenderSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#1D1D22",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.397 2.5c.333 0 .603.27.603.603v16.294c0 .333-.27.603-.603.603H.603A.603.603 0 0 1 0 19.397V3.103C0 2.77.27 2.5.603 2.5h18.794zm-1.466 1.667H2.07a.402.402 0 0 0-.402.402V17.93c0 .222.18.402.402.402h15.86c.222 0 .402-.18.402-.402V4.57a.402.402 0 0 0-.402-.402z"
  }), /*#__PURE__*/React.createElement("rect", {
    fillRule: "nonzero",
    x: 3.333,
    width: 1.667,
    height: 3.333,
    rx: 0.201
  }), /*#__PURE__*/React.createElement("rect", {
    fillRule: "nonzero",
    x: 15,
    width: 1.667,
    height: 3.333,
    rx: 0.201
  }), /*#__PURE__*/React.createElement("rect", {
    fillRule: "nonzero",
    x: 4.167,
    y: 8.333,
    width: 3.333,
    height: 3.333,
    rx: 0.201
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M1.667 6.667v-2.5h16.666v2.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalenderSearchIcon);
export default __webpack_public_path__ + "static/media/calender-search-icon.cd4455d423ed35a68ba7dac1d494d6d8.svg";
export { ForwardRef as ReactComponent };